import { Layout } from "@/components/layout/Layout";
import { HomeSections } from "@/components/home/HomeSections";
import { PageSeo } from "@/components/seo/PageSeo";
import { LocalBusinessJsonLd } from "@/components/seo/LocalBusinessJsonLd";

const Index = () => (
  <Layout>
    <PageSeo pageSlug="home" fallbackTitle="Home" fallbackDescription="Professional cleaning services and online booking." />
    <LocalBusinessJsonLd />
    <HomeSections />
  </Layout>
);

export default Index;
